import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { en } from '../data/copy.en';
import { es } from '../data/copy.es';
import type { Copy, Lang } from '../types/copy';
interface LanguageValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Copy;
}
const dictionaries: Record<Lang, Copy> = {
  en,
  es
};
const LanguageContext = createContext<LanguageValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>('en');
  const setLang = useCallback((next: Lang) => {
    setLangState(next);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = next;
    }
  }, []);
  const value = useMemo<LanguageValue>(() => ({
    lang,
    setLang,
    t: dictionaries[lang]
  }), [lang, setLang]);
  return <LanguageContext.Provider value={value} data-id="element-400" data-mp="2elc1v60u0hra">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used inside a LanguageProvider');
  }
  return ctx;
}